// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"eV-z","sponsoredTooltipWrapper":"fV-z","sponsoredTooltip":"gV-z","newCard":"hV-z"};